/**
 * BtmViabilitySection (btmViability) — the Executive Summary's BTM energy-path
 * viability synthesis. W2c editorial port: the bare roleColor'd <p> moves into
 * an EditorialSubsection (small-caps analytical-lens label + themed body) so
 * every preset renders the journal / institutional / compact chrome. The
 * narrative content, the [n] claim walking, and the empty-section semantics
 * are unchanged.
 */
import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { walkClaimsText } from '../../../../lib/walkClaimsText';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

interface Props {
  report: SiteRagReport;
  label: string;
}

export const BtmViabilitySection: React.FC<Props> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const text = report.btmViabilityAssessment?.trim() ?? '';
  return (
    <SectionShell
      label={label}
      hasData={text.length > 0}
      report={report}
      sectionId="btmViability"
      pagedForwardFold
    >
      {text.length > 0 && (
        <EditorialSubsection theme={theme} label="Viability Synthesis">
          {/* Post-W0 the themed ink + body face are inherited — only the
              newline-preserving behaviour of the original prose is kept. */}
          <p className="whitespace-pre-wrap m-0">
            {walkClaimsText(text, report.references, report.claims)}
          </p>
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
